<template>
    <div v-if="showWithdrawMoney" class="containerDeposit">
        <UseDialog :title="l('qk')" :closeCallBack="closeCallBack" width="605">
            <template #content>
                <div v-loading="loading" class="content">
                    <p class="font18" style="color:#39270c;">取款方式</p>
                    <div class="rechargeMethod flex warp">
                        <p @click="changeWithdrawMoneyMethodFn(index)" v-for="(item,index) in withdrawMoneyMethod"
                           :key="index"
                           :class="{currentRechargeMethod:currentWithdrawMoneyMethod === index}"
                           class="font16 pointer bold flex alignItemsCenter justifyContentCenter">{{item.name}}</p>
                    </div>
                    <div class="flex justifyContentSpaceBetween">
                        <p class="font18" style="color:#39270c;">
                            {{withdrawMoneyMethod[currentWithdrawMoneyMethod]?.name}}钱包
                            （{{withdrawMoneyMethod[currentWithdrawMoneyMethod]?.child.length}}/{{withdrawMoneyMethod[currentWithdrawMoneyMethod]?.maximum}}）
                        </p>
                        <template
                                v-if="withdrawMoneyMethod[currentWithdrawMoneyMethod]?.child.length < withdrawMoneyMethod[currentWithdrawMoneyMethod]?.maximum">
                            <div @click="openAddAccount" class="currentBank transformScale098 font12 colorb7874a">
                                <span>新增</span>
                            </div>
                        </template>
                    </div>
                    <div class="bankList">
                        <template v-if="withdrawMoneyMethod[currentWithdrawMoneyMethod]?.child?.length !== 0">
                            <div @click="changeWithdrawMoneyMethodBankFn(item,index)"
                                 v-for="(item,index) in withdrawMoneyMethod[currentWithdrawMoneyMethod]?.child"
                                 :key="index" class="item relative transformScale098 borderBox flex alignItemsCenter">
                                <!--                                <div class="flex alignItemsCenter">-->
                                <!--                                    <img style="width:52px;height:52px;" src="/images/withdrawMoney/jia.png" alt="">-->
                                <!--                                </div>-->
                                <div class="font14 flex1 flex column" style="margin-left: 15px;">
                                    <p>
                                        <span class="color6a6153">{{item.bankName}}</span>
                                    </p>
                                    <p class="colorb7874a" style="margin: 10px 0px;">{{item.realName}}</p>
                                    <p class="bold color39270c">{{countShowAccount(item?.cardNum)}}</p>
                                </div>
                                <div v-show="currentWithdrawMoneyMethodBank === index"
                                     class="currentBank font12 colorb7874a absolute">
                                    <span>当前</span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div @click="openAddAccount"
                                 class="item noOne transformScale098 borderBox flex alignItemsCenter">
                                <div class="flex alignItemsCenter">
                                    <img style="width:52px;height:52px;" src="/images/withdrawMoney/jia.png" alt="">
                                </div>
                                <div class="flex1 flex column" style="margin-left: 15px;">
                                    <p style="margin-bottom: 15px;">
                                        <span class="color39270c">暂无虚拟币钱包地址 </span>
                                        <span class="color9c896d">请添加</span>
                                    </p>
                                    <p class="font14 color000">**** **** **** ****</p>
                                </div>
                                <div class="addAccount colorb7874a">
                                    + 新增
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="moneyBox borderBox">
                        <p class="color39270c">取款金额（{{goldUnit()}}）</p>
                        <div class="inputMoney flex alignItemsCenter" style="margin-top: 20px;">
                            <span class="font22">{{goldUnit()}}</span>
                            <input @input="rounding" v-model="formData.money"
                                   :placeholder="`输入金额，单笔取款${goldUnit()}10~${goldUnit()}1,000,000`"
                                   class="flex1 font16" type="number">
                            <div @click="autoMoney"
                                 class="font14 hover pointer flex alignItemsCenter justifyContentCenter">最大金额
                            </div>
                        </div>
                        <div style="margin:15px 0px;height: 1px;background-color: #e6e2dd;"></div>
                        <!--                        <div class="flex justifyContentSpaceBetween">-->
                        <!--                            <div class="flex alignItemsCenter color6a6153">-->
                        <!--                                <p>还需</p>-->
                        <!--                                <p style="color:#eb3333;">{{goldUnit()}}</p>-->
                        <!--                                <use-tooltip>-->
                        <!--                                    <template #content>-->
                        <!--                                        <img class="pointer" style="width: 18px;height: 18px;margin: 0px 5px;"-->
                        <!--                                             src="/images/myWallet/wenhao.png" alt="">-->
                        <!--                                    </template>-->
                        <!--                                </use-tooltip>-->
                        <!--                                <p>有效流水才能取款</p>-->
                        <!--                            </div>-->
                        <!--                            <div class="font12 colorb7874a flex">-->
                        <!--                                <p style="margin-right: 20px;">手续费{{goldUnit()}}</p>-->
                        <!--                                <p>预计到账金额{{goldUnit()}}</p>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <!--                        <div style="margin-top:15px;margin-bottom:10px;">-->
                        <!--                            <span class="font12 coloraea28e">当日剩余取款额度{{goldUnit(300000)}},单笔取款金额范围{{goldUnit()}}50~{{goldUnit()}}300,000,今日剩余取款次数5次。</span>-->
                        <!--                        </div>-->
                        <p class="font16" style="color:#39270c;margin-top:20px;">取款密码</p>
                        <div style="margin-top: 20px;">
                            <div class="inputMoney flex alignItemsCenter">
                                <span class="font22" style="visibility: hidden;">{{goldUnit()}}</span>
                                <input v-model="formData.pinCode" placeholder="请输入取款密码" class="flex1 font16"
                                       type="password">
                            </div>
                        </div>
                        <div style="margin:15px 0px;height: 1px;background-color: #e6e2dd;"></div>
                        <div @click="submitBtnFn"
                             class="submitBtn font18 colorfff pointer hover flex alignItemsCenter justifyContentCenter">
                            <span>立即取款</span>
                        </div>
                    </div>
                    <div class="shortcuts font14 flex justifyContentSpaceBetween alignItemsCenter">
                        <p class="textAlignCenter hover pointer">存取记录</p>
                        <p>充值遇到问题？<span @click="toOnlineService" class="hover pointer">联系客服</span>解决</p>
                    </div>
                </div>
            </template>
        </UseDialog>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    import {getTellerTagApi, getUserBankApi, cashOutApi} from "@/api"

    export default {
        name: "index",
        computed: {
            ...mapState(['showWithdrawMoney', 'userInfo']),
        },
        data() {
            return {
                withdrawMoneyMethod: [], //取款方式集合
                currentWithdrawMoneyMethod: '',//当前的取款方式 会采用方法changeWithdrawMoneyMethodFn 默认成0
                currentWithdrawMoneyMethodBank: '',  //当前银行卡
                formData: {money: '', pinCode: '', bankId: ''},  //表单
                paymentChannel: {current: 0, list: []}, //支付渠道
                quickAmount: {current: 0},//快捷支付
                loading: false,
            }
        },
        watch: {
            showWithdrawMoney: {
                handler(newVal, oldVal) {
                    if (newVal) {
                        this.useInterceptedOnMounted(this.init)
                    }
                }, immediate: true
            }
        },
        methods: {
            init() {
                this.loading = true
                Promise.all([getTellerTagApi(), getUserBankApi()]).then(res => {

                    //失败拦截
                    if (res.filter(item => !item.data).length > 0) return

                    let res0 = res[0].data.result || []
                    let res1 = res[1].data.result || []

                    res0.forEach((item, index) => {
                        if (!item.child) item.child = []

                        res1.forEach((l, i) => {
                            if (l.accountType === item.id) {
                                item.child.push(l)
                            }
                        })
                    })

                    this.withdrawMoneyMethod = [...res0]
                    //默认选中第一项
                    this.changeWithdrawMoneyMethodFn(0)

                    setTimeout(() => {
                        this.loading = false
                    }, 300)
                })
            },
            closeCallBack() {
                this.setStoreState({prop: 'showWithdrawMoney', value: false})
            },
            changeWithdrawMoneyMethodFn(index) {  //切换支付方式
                this.currentWithdrawMoneyMethod = index
                //清空金额
                this.formData.money = ''
                //清空当前选择的银行卡
                this.currentWithdrawMoneyMethodBank = ''
                // this.paymentChannel = {
                //     current: 0,
                //     list: this.withdrawMoneyMethod[index].child || []
                // }
            },
            changeWithdrawMoneyMethodBankFn(item, index) { //切换银行卡
                this.currentWithdrawMoneyMethodBank = index

                //修改bankId
                this.formData.bankId = item.id
            },
            changePaymentChannelFn(index) { //切换支付渠道
                if (this.paymentChannel.current === index) return
                this.paymentChannel.current = index
                //清空金额
                this.formData.money = ''
                //清空密码
                this.formData.pinCode = ''
                //清空cardId
                this.formData.bankId = ''
            },
            countShowAccount(str) {
                if (!str) return ''
                // return

                //如果是电话号则中间截取
                const phoneRegex = /^[+]?[0-9]{1,4}?[-.\s]?(\(?\d{1,4}\)?[-.\s]?)?\d{1,4}[-.\s]?\d{1,9}$/

                if (str.match(phoneRegex)) {
                    return `${str.substr(0, 4)} **** ${str.substr(-4)}`
                }

                return `**** **** **** ${str.substr(-4)}`
            },
            autoMoney() {    //最大金额 为账户的余额
                this.formData.money = parseInt(this.userInfo.balance)
            },
            async submitBtnFn() { //立即取款
                if (!this.userInfo.hasPinCode) {
                    const _this = this
                    this.$confirm('您还未设置取款密码，请先设置取款密码', '提示', {
                        confirmButtonText: '去设置',
                        cancelButtonText: '取消',
                        type: 'warning',
                        // center: true
                    }).then(() => {
                        _this.setStoreState({prop: 'showWithdrawMoney', value: false})
                        _this.$router.push({path: '/userCenter/securityCenter'}).catch(err=>'')
                    }).catch(() => {

                    })
                    return
                }
                // money: '', pinCode: '', bankId: ''
                let {money: _money, pinCode: _pinCode, bankId: _bankId} = this.formData

                if (!_bankId) {
                    this.$message({type: 'error', message: '请选择取款钱包'})
                    return
                }
                if (!_money) {
                    this.$message({type: 'error', message: '请输入存款金额'})
                    return
                }
                if (!_pinCode) {
                    this.$message({type: 'error', message: '请输入取款密码'})
                    return
                }
                let _data = {
                    pinCode: _pinCode,
                    amount: Number(_money),
                    bankId: _bankId,
                }

                this.loading = true


                let cashOutApiResp = await cashOutApi(_data)

                this.loading = false

                if (cashOutApiResp.message !== 'success') return

                //刷新个人信息
                await this.updateInfo()

                //清空金额
                this.formData.money = ''
                //清空密码
                this.formData.pinCode = ''

                this.$message({type: 'success', message: '取款成功'})
            },
            openAddAccount() {
                //判断是否已经绑定了电话号码和真实姓名 没有则提示
                if (!this.userInfo.realName || !this.userInfo.phone) {
                    const _this = this
                    this.$confirm('您还未绑定个人信息', '提示', {
                        confirmButtonText: '去绑定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        // center: true
                    }).then(() => {
                        _this.setStoreState({prop: 'showWithdrawMoney', value: false})
                        _this.$router.push({path: '/userCenter/securityCenter'}).catch(err=>'')
                    }).catch(() => {

                    })
                    return
                }


                //缓存当前的设置
                sessionStorage.setItem('currentBank', JSON.stringify(this.withdrawMoneyMethod[this.currentWithdrawMoneyMethod]))

                this.setStoreState({prop: 'showAddAccount', value: true})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .containerDeposit {
        .content {
            padding: 20px;

            .rechargeMethod {
                margin-top: 15px;

                P {
                    height: 40px;
                    margin-right: 15px;
                    margin-bottom: 15px;
                    padding: 0px 25px;
                    color: #39270c;
                    background: url("@images/deposit/bmhcz_bg.png") no-repeat center center/100% 100%;

                    &:hover {
                        color: #fff;
                        background: url("@images/deposit/usdtcz_bg.png") no-repeat center center/100% 100%;
                    }

                    &.currentRechargeMethod {
                        color: #fff;
                        background: url("@images/deposit/usdtcz_bg.png") no-repeat center center/100% 100%;
                    }
                }
            }

            .currentBank {
                top: 10px;
                right: 20px;
                padding: 5px 10px;
                background-color: #f1ede8;
                border-radius: 6px;
                border: solid 1px #b7874a;
            }

            .bankList {
                margin-top: 15px;
                max-height: 200px;
                overflow-y: auto;

                .item {
                    height: 90px;
                    padding: 0px 20px;
                    margin-bottom: 15px;
                    background: url("@images/withdrawMoney/qukuan_bg01.png") no-repeat center center/100% 100%;
                }

                .noOne {
                    .addAccount {
                        padding: 12px 18px;
                        border-radius: 19px;
                        border: solid 1px #b7874a;
                    }
                }
            }


            .moneyBox {
                /*height: 250px;*/
                padding: 20px 20px;
                background: url("@images/withdrawMoney/qukuan_bg02.png") no-repeat center center/100% 100%;

                .inputMoney {
                    > input {
                        margin: 0px 15px;
                    }

                    > div {
                        width: 88px;
                        height: 36px;
                        background-color: #ffffff;
                        border-radius: 18px;
                        border: solid 1px #b7874a;
                        color: #b7874a;
                    }
                }
            }

            .submitBtn {
                height: 50px;
                margin-top: 10px;
                background: url("@images/deposit/ck_ljck.png") no-repeat center center/100% 100%;
            }

            .shortcuts {
                margin-top: 15px;

                p:first-child {
                    width: 85px;
                    height: 33px;
                    line-height: 33px;
                    background-color: #eae4dc;
                    border-radius: 17px;
                    color: #b7874a;
                }

                p:nth-child(2) {
                    color: #aea28e;

                    span {
                        color: #b7874a;
                    }
                }
            }
        }
    }
</style>
